module.exports = __webpack_public_path__ + "img/p1-3.4455c569.png";